import { useContext } from 'react'

import { Context, defaultValue, VersionContext } from './VersionContext.js'

export function useVersion(): Context {
  const context = useContext(VersionContext)

  if (context === defaultValue) {
    throw new Error('not used within a VersionProvider.')
  }

  return context
}
